(function () {
  'use strict';

  var COVERED_VARIANT_PROPERTY = '_dovr_warranty_for';
  var lastSyncAttempt = '';

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (content) {
        if (!response.ok) {
          throw new Error(content.description || content.message || response.statusText);
        }

        return content;
      });
    });
  }

  function addPlan(planVariantId, quantity, coveredVariantId, covers) {
    var properties = { Covers: covers };
    properties[COVERED_VARIANT_PROPERTY] = String(coveredVariantId);

    return postJson(window.routes.cartAddUrl + '.js', {
      items: [{ id: parseInt(planVariantId, 10), quantity: quantity, properties: properties }]
    });
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { scrollToTop: false }
    }));
  }

  /**
   * ---------------------------------------------------------------------------------------------------
   * PRODUCT PAGE
   * ---------------------------------------------------------------------------------------------------
   */

  function getVariants(widget) {
    return JSON.parse(widget.querySelector('[data-dovr-warranty-variants]').textContent);
  }

  function getSelectedPlanId(widget) {
    if (widget.querySelector('[data-dovr-warranty-decline]').checked) {
      return null;
    }

    return widget.querySelector('[data-dovr-warranty-plan]').value || null;
  }

  // The class also hides the dynamic checkout button (see dovr-warranty.css), which would skip the plan
  function updateState(widget) {
    widget.classList.toggle('dovr-warranty--plan-selected', getSelectedPlanId(widget) !== null);
    widget.classList.toggle('dovr-warranty--declined', widget.querySelector('[data-dovr-warranty-decline]').checked);
  }

  document.addEventListener('change', function (event) {
    var widget = event.target.closest('[data-dovr-warranty]');

    if (!widget) {
      return;
    }

    if (event.target.matches('[data-dovr-warranty-plan]') && event.target.value) {
      widget.querySelector('[data-dovr-warranty-decline]').checked = false;
    }

    updateState(widget);
  });

  // When the plan to preselect depends on the item price, follow the variant, unless the customer picked another plan
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail.variant;
    var previousVariant = event.detail.previousVariant;

    event.target.querySelectorAll('[data-dovr-warranty]').forEach(function (widget) {
      var variants = getVariants(widget);
      var select = widget.querySelector('[data-dovr-warranty-plan]');
      var current = variant && variants[variant.id];
      var previous = previousVariant && variants[previousVariant.id];

      if (current && previous && select.value === String(previous.plan)) {
        select.value = String(current.plan);
      }
    });
  });

  // Captured on window so it runs before the theme's own "product:added" listener: we hold that event back, add the
  // plan, then send it again so the mini-cart re-renders once with both items.
  window.addEventListener('product:added', function (event) {
    var detail = event.detail || {};
    var form = detail.button && detail.button.closest('form');
    var widget = form && form.querySelector('[data-dovr-warranty]');
    var planId = widget && getSelectedPlanId(widget);

    if (detail.dovrWarrantyHandled || !planId) {
      return;
    }

    event.stopImmediatePropagation();

    var source = event.target;
    var variantId = form.querySelector('[name="id"]').value;
    var variant = getVariants(widget)[variantId];
    var covers = variant ? variant.covers : (detail.variant && detail.variant.name) || '';
    var quantity = detail.quantity || 1;
    var addedQuantity = 0;

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    addPlan(planId, quantity, variantId, covers)
      .then(function () {
        addedQuantity = quantity;
      })
      .catch(function (error) {
        console.error('Could not add the protection plan:', error);
      })
      .then(function () {
        source.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: Object.assign({}, detail, { quantity: quantity + addedQuantity, dovrWarrantyHandled: true })
        }));
      });
  }, true);

  /**
   * ---------------------------------------------------------------------------------------------------
   * CART AND MINI-CART
   * ---------------------------------------------------------------------------------------------------
   */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-action="dovr-add-warranty"]');

    if (!button) {
      return;
    }

    event.preventDefault();
    button.disabled = true;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    addPlan(
      button.closest('[data-dovr-warranty-offer]').querySelector('[data-dovr-warranty-offer-plan]').value,
      parseInt(button.getAttribute('data-quantity'), 10),
      button.getAttribute('data-covered-variant-id'),
      button.getAttribute('data-covers')
    )
      .catch(function (error) {
        console.error('Could not add the protection plan:', error);
      })
      .then(refreshCart);
  });

  function syncPlanQuantities() {
    var updates = {};

    document.querySelectorAll('[data-dovr-warranty-sync]').forEach(function (element) {
      Object.assign(updates, JSON.parse(element.textContent));
    });

    var attempt = JSON.stringify(updates);

    if (attempt === '{}') {
      lastSyncAttempt = '';
      return;
    }

    // Never send the same correction twice in a row, so a failing update can't loop with the re-render
    if (attempt === lastSyncAttempt) {
      return;
    }

    lastSyncAttempt = attempt;

    postJson(window.routes.cartUrl + '/update.js', { updates: updates })
      .then(refreshCart)
      .catch(function (error) {
        console.error('Could not update protection plan quantities:', error);
      });
  }

  document.addEventListener('DOMContentLoaded', syncPlanQuantities);

  // The mini-cart dispatches "cart:rerendered" without bubbling, hence the capture
  document.addEventListener('cart:rerendered', syncPlanQuantities, true);
})();
